import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  // ✅ CORREGIDO: MainPaper dinámico según tema
  mainPaper: {
    flex: 1,
    padding: theme.spacing(3),
    paddingBottom: 100,
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#f8f9fa',
    borderRadius: '12px',
    boxShadow: theme.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.1)',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
  },
  // ✅ CORREGIDO: MainHeader dinámico según tema
  mainHeader: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
  // ✅ CORREGIDO: SectionCard dinámico según tema
  sectionCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: theme.mode === 'dark' ? '0 4px 6px rgba(0, 0, 0, 0.3)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e1e5e9'}`,
    backgroundColor: theme.palette.background.paper,
  },
  // ✅ CORREGIDO: SectionHeader dinámico según tema
  sectionHeader: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: '12px 12px 0 0'
  },
  formContainer: {
    maxWidth: 500,
    padding: theme.spacing(2)
  },
  textRight: {
    textAlign: "right"
  },
  // ✅ CORREGIDO: InfoBox dinámico según tema
  infoBox: {
    backgroundColor: theme.mode === 'dark' ? '#1e3a5f' : '#e8f4fd',
    border: `1px solid ${theme.mode === 'dark' ? '#2d4f7a' : '#bee5eb'}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: theme.mode === 'dark' ? theme.palette.primary.light : '#1976d2',
  },
  // ✅ CORREGIDO: FileUploadArea dinámico según tema
  fileUploadArea: {
    border: `2px dashed ${theme.palette.primary.main}`,
    borderRadius: 8,
    padding: theme.spacing(3),
    textAlign: 'center',
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa',
    color: theme.palette.text.primary,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#e3f2fd',
      borderColor: theme.palette.primary.dark || '#2980b9'
    }
  },
  // ✅ CORREGIDO: FileInfo dinámico según tema
  fileInfo: {
    marginTop: theme.spacing(1),
    fontSize: '0.875rem',
    color: theme.palette.text.secondary || theme.palette.text.primary,
  },
  // ✅ CORREGIDO: EndpointBox dinámico según tema
  endpointBox: {
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#2c3e50',
    color: 'white',
    padding: theme.spacing(1),
    borderRadius: 4,
    fontFamily: 'monospace',
    fontSize: '0.875rem',
    margin: theme.spacing(1, 0)
  },
  limitChip: {
    backgroundColor: '#27ae60',
    color: 'white',
    fontWeight: 'bold'
  },
  methodChip: {
    backgroundColor: '#e74c3c',
    color: 'white',
    fontWeight: 'bold'
  },
  headerChip: {
    backgroundColor: '#9b59b6',
    color: 'white',
    fontWeight: 'bold'
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
  buttonProgress: {
    color: theme.palette.success.main,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  btnWrapper: {
    position: "relative",
  },
  elementMargin: {
    marginBottom: theme.spacing(2),
  },

  // ===== F1: API Reference profesional =====
  layout: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: { flexDirection: 'column' },
  },
  sidebar: {
    position: 'sticky',
    top: theme.spacing(2),
    width: 220,
    flexShrink: 0,
    alignSelf: 'flex-start',
    [theme.breakpoints.down('sm')]: { position: 'static', width: '100%' },
  },
  sidebarInner: {
    borderRadius: 12,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e1e5e9'}`,
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
  },
  navItem: {
    display: 'block',
    padding: theme.spacing(1.25, 2),
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    borderLeft: '3px solid transparent',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f1f5f9',
      color: theme.palette.primary.main,
      borderLeftColor: theme.palette.primary.main,
    },
  },
  content: { flex: 1, minWidth: 0 },
  authCard: {
    borderRadius: 12,
    border: `1px solid ${theme.mode === 'dark' ? '#3b4a6b' : '#bcd4ff'}`,
    background: theme.mode === 'dark' ? '#16233d' : '#eef4ff',
    padding: theme.spacing(2, 2.5),
    marginBottom: theme.spacing(3),
  },
  sectionAnchor: {
    fontSize: 20,
    fontWeight: 800,
    color: theme.palette.text.primary,
    margin: theme.spacing(3, 0, 1.5, 0),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    scrollMarginTop: theme.spacing(2),
  },
  epCard: {
    borderRadius: 12,
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e1e5e9'}`,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(2),
  },
  epHead: { display: 'flex', alignItems: 'center', gap: theme.spacing(1), flexWrap: 'wrap' },
  methodBadge: {
    fontWeight: 800,
    fontSize: 12,
    letterSpacing: 0.5,
    color: '#fff',
    borderRadius: 6,
    padding: theme.spacing(0.5, 1.25),
  },
  epPath: {
    flex: 1,
    minWidth: 0,
    fontFamily: 'monospace',
    fontSize: 14,
    color: theme.palette.text.primary,
    wordBreak: 'break-all',
  },
  epTitle: {
    fontSize: 15,
    fontWeight: 700,
    color: theme.palette.text.primary,
    margin: theme.spacing(1.5, 0, 0.5, 0),
  },
  epDesc: { fontSize: 13.5, color: theme.palette.text.secondary, marginBottom: theme.spacing(1) },
  paramTable: {
    width: '100%',
    borderCollapse: 'collapse',
    margin: theme.spacing(1, 0),
    '& th, & td': {
      textAlign: 'left',
      padding: theme.spacing(0.75, 1),
      borderBottom: `1px solid ${theme.mode === 'dark' ? '#374151' : '#eceff3'}`,
      fontSize: 13,
    },
    '& th': { color: theme.palette.text.secondary, fontWeight: 700, textTransform: 'uppercase', fontSize: 11, letterSpacing: 0.5 },
    '& td:first-child': { fontFamily: 'monospace', fontWeight: 700, color: theme.palette.text.primary, whiteSpace: 'nowrap' },
    '& td:last-child': { color: theme.palette.text.secondary },
  },
  codeLabel: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
  },
  codeBlock: {
    position: 'relative',
    backgroundColor: theme.mode === 'dark' ? '#0f172a' : '#1e293b',
    color: '#e2e8f0',
    borderRadius: 8,
    padding: theme.spacing(1.5, 5, 1.5, 1.5),
    fontFamily: 'monospace',
    fontSize: 12.5,
    lineHeight: 1.6,
    overflowX: 'auto',
    whiteSpace: 'pre',
  },
  copyBtn: {
    position: 'absolute',
    top: 6,
    right: 6,
    color: '#94a3b8',
    padding: 6,
    '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.08)' },
  },
  comingSoon: {
    display: 'inline-block',
    fontSize: 11,
    fontWeight: 700,
    color: '#b45309',
    backgroundColor: theme.mode === 'dark' ? '#3a2e12' : '#fef3c7',
    border: `1px solid ${theme.mode === 'dark' ? '#5b4610' : '#fde68a'}`,
    borderRadius: 6,
    padding: theme.spacing(0.25, 1),
    marginLeft: theme.spacing(1),
  },
}));
